// __DRIVER_STOP_UNBILLED__ (2026-09-29) which load_stops rows are the CUSTOMER's.
//
// Henry: a stop the driver adds in the driver app (1.35 ADD STOP: fuel or break) "doesn't get
// priced or mentioned on an invoice but does stay in the system for an accurate history purpose".
//
// Billable <=> stop_type pickup / delivery (or blank on a legacy row) AND not driver_added.
// load_stops.driver_added is set by the DB trigger trg_load_stops_driver_added. Same rule as the
// hub's billable_stops.py. Route plans, live ETAs, dwell and the stop list keep EVERY stop;
// copy / clone / export / anything priced or customer-facing uses billableStops().
// Nothing here names driver_added in a query, so dropping the column cannot break the board.

export const CUSTOMER_STOP_TYPES = ['pickup', 'delivery'];

export const isBillableStop = (s) => {
  if (!s || typeof s !== 'object') return false;
  if (s.driver_added === true) return false;
  const t = String(s.stop_type || '').trim().toLowerCase();
  return t === '' || CUSTOMER_STOP_TYPES.includes(t);
};

export const isDriverStop = (s) => !!s && typeof s === 'object' && !isBillableStop(s);

export const billableStops = (stops) => (stops || []).filter(isBillableStop);

export const driverStopTag = (s) => {
  const t = String((s && s.stop_type) || '').toLowerCase();
  return t === 'break' ? 'B' : t === 'fuel' ? 'F' : 'X';
};
